import React from 'react'
import PropTypes from 'prop-types'
import { graphql, compose } from 'react-apollo'
import Header from './Header'
import Subheader from './Subheader'
import Main from './Main'
import Emulator from './Emulator'
import QuicklinksModal from '~/components/layout/QuicklinksModal'
import SearchModal from '~/components/layout/SearchModal'
import { QueryProfile } from '~/queries/user.gql'
import useToggle from '~/hooks/useToggle'

function LayoutPublic ({ children, authorized, url, mainClassName }) {
  return (
    <>
      <Header
        url={url}
        publicAccess
      />

      <Main authorized={authorized} mainClassName={mainClassName}>
        {children}
      </Main>
    </>
  )
}

function LayoutAuthenticated ({ children, authorized, title, mainClassName, url, data }) {
  const [quicklinksModalOpen, toggleQuickLinksModal] = useToggle()
  const [searchModalOpen, toggleSearchModal] = useToggle()
  const profile = { session: data.session, user: data.user }

  // Add additional props to children
  const newChildren = React.cloneElement(children, {
    profile,
    toggleQuickLinksModal,
    toggleSearchModal
  })

  return (
    <>
      <Emulator profile={profile} />
      <Header
        url={url}
        profile={profile}
        toggleQuickLinksModal={toggleQuickLinksModal}
        toggleSearchModal={toggleSearchModal}
        publicAccess={false}
      />
      <Subheader
        url={url}
        profile={profile}
      />
      <Main authorized={authorized} mainClassName={mainClassName}>
        {newChildren}
      </Main>
      <QuicklinksModal
        profile={profile}
        quicklinksModalOpen={quicklinksModalOpen}
        toggleQuickLinksModal={toggleQuickLinksModal}
      />
      <SearchModal
        title={title}
        searchModalOpen={searchModalOpen}
        toggleSearchModal={toggleSearchModal}
      />
    </>
  )
}

function Layout ({ children, authorized, publicAccess, title, mainClassName, url, data }) {
  if (publicAccess) {
    return (
      <LayoutPublic
        children={children}
        authorized={authorized}
        url={url}
        mainClassName={mainClassName}
      />
    )
  } else {
    return (
      <LayoutAuthenticated
        children={children}
        authorized={authorized}
        title={title}
        mainClassName={mainClassName}
        url={url}
        data={data}
      />
    )
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  authorized: PropTypes.bool.isRequired,
  publicAccess: PropTypes.bool.isRequired,
  profile: PropTypes.object,
  title: PropTypes.string,
  url: PropTypes.object,
  mainClassName: PropTypes.string
}

const withUser = graphql(QueryProfile, {
  skip: ({ publicAccess }) => publicAccess,
  options: () => ({
    variables: {
      id: 'me'
    }
  })
})

export default compose(
  withUser
)(Layout)
